import { render, staticRenderFns } from "./save-documentation-folder-dialog.component.vue?vue&type=template&id=01501524"
import script from "./save-documentation-folder-dialog.component.ts?vue&type=script&lang=ts&external"
export * from "./save-documentation-folder-dialog.component.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/foex-3r/foex-3r-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('01501524')) {
      api.createRecord('01501524', component.options)
    } else {
      api.reload('01501524', component.options)
    }
    module.hot.accept("./save-documentation-folder-dialog.component.vue?vue&type=template&id=01501524", function () {
      api.rerender('01501524', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/shared/save-documentation-folder-dialog/save-documentation-folder-dialog.component.vue"
export default component.exports